import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
var $ = jQuery;
var VideoGallery = /*#__PURE__*/function () {
  function VideoGallery() {
    _classCallCheck(this, VideoGallery);
    this.player;
    this.pipReady;
    this.pipActive;
    this.selector = '.VideoGallery';
    this.$el = $(this.selector);
    if (!this.$el) return;
    this.$playerWrapper = this.$el.find("".concat(this.selector, "-playerWrapper"));
    this.$player = this.$el.find('#player');
    this.$closePip = this.$el.find("".concat(this.selector, "-closePip"));
    this.$thumbnails = this.$el.find('.VideoThumbnail');
    this.$current = this.$thumbnails.filter('[data-current="true"]').first();
    this.bindEvents();
    this.loadScript();
  }

  /*
   * Init
   */
  _createClass(VideoGallery, [{
    key: "loadScript",
    value: function loadScript() {
      // Load YouTube player API
      var s = document.createElement('script');
      s.src = "https://www.youtube.com/iframe_api";
      document.head.appendChild(s);
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var _this = this;
      window.onYouTubeIframeAPIReady = this.onYouTubeIframeAPIReady.bind(this);
      this.$thumbnails.on('click', function (e) {
        return _this.onClickThumbnail(e);
      });
    }

    /*
     * Event Handlers
     */
  }, {
    key: "onYouTubeIframeAPIReady",
    value: function onYouTubeIframeAPIReady() {
      var videoID = this.$current.attr('data-id');
      this.player = new YT.Player('player', {
        height: '1920',
        width: '1080',
        videoId: videoID,
        playerVars: {
          'playsinline': 1,
          'rel': 0
        },
        events: {
          'onReady': this.onPlayerReady.bind(this),
          'onStateChange': this.onPlayerStateChange.bind(this)
        }
      });
    }
  }, {
    key: "onPlayerReady",
    value: function onPlayerReady(e) {
      // console.log('player ready', e);
    }
  }, {
    key: "onPlayerStateChange",
    value: function onPlayerStateChange(e) {
      switch (e.data) {
        // ended
        case 0:
        // paused
        case 2:
        // unstarted
        case -1:
          this.setPipReady(false);
          break;
        // playing
        default:
        case 1:
          this.setPipReady(true);
          break;
      }
    }
  }, {
    key: "onClickThumbnail",
    value: function onClickThumbnail(e) {
      var $thumbnail = $(e.currentTarget);
      this.selectVideo($thumbnail);
    }
  }, {
    key: "onScrollPip",
    value: function onScrollPip() {
      // TODO: cache this values on resize rather than getting them every scroll?
      var box = this.$playerWrapper[0].getBoundingClientRect();
      var win = {
        h: $(window).height(),
        w: $(window).width()
      };
      var nonPipPlayerHeight = this.$playerWrapper.width() * 9 / 16;
      var offset = nonPipPlayerHeight / 3 * 2;
      var topDistance = this.$playerWrapper.height() + box.top - offset;
      var bottomDistance = win.h - (box.top + offset);
      if (this.pipActive) {
        if (topDistance >= 0 && bottomDistance >= 0) {
          this.setPipActive(false);
        }
      } else {
        if (topDistance < 0 || bottomDistance < 0) {
          this.setPipActive(true);
        }
      }
    }

    /*
     * Actions
     */
  }, {
    key: "setPipReady",
    value: function setPipReady(bool) {
      if (bool === this.pipReady) {
        return;
      }
      ;
      this.pipReady = bool;
      this.$el.attr('data-pip-ready', bool);
      this.togglePipEvents();
    }
  }, {
    key: "setPipActive",
    value: function setPipActive(bool) {
      var _this2 = this;
      if (bool === this.pipActive) {
        return;
      }
      this.pipActive = bool;
      this.$el.attr("data-pip-".concat(bool ? 'activating' : 'deactivating'), true);
      setTimeout(function () {
        _this2.$el.attr('data-pip-active', bool);
        _this2.$el.attr("data-pip-".concat(bool ? 'activating' : 'deactivating'), false);
      }, 1);
      this.togglePipEvents();
    }
  }, {
    key: "togglePipEvents",
    value: function togglePipEvents() {
      // scroll
      if (this.pipActive || this.pipReady) {
        $(window).on('scroll.pip', this.onScrollPip.bind(this));
      } else {
        $(window).off('scroll.pip');
      }

      // close
      if (this.pipActive) {
        this.$closePip.on('click.closePip', this.closePip.bind(this));
      } else {
        this.$closePip.off('click.closePip');
      }
    }
  }, {
    key: "closePip",
    value: function closePip() {
      this.player.pauseVideo();
      this.setPipActive(false);
    }
  }, {
    key: "selectVideo",
    value: function selectVideo($thumbnail) {
      // deselect current video thumbnail
      if (this.$current) {
        this.$current.attr('data-current', false);
      }
      this.$current = $thumbnail;
      this.$current.attr('data-current', true);
      var videoID = this.$current.attr('data-id');
      this.player.loadVideoById(videoID);
      this.player.unMute();

      // check initial scroll position for PIP
      this.onScrollPip();
    }
  }]);
  return VideoGallery;
}();
export { VideoGallery as default };